module.exports = __webpack_public_path__ + "static/img/apro7wifi.a4e14185.png";